import React, { type ReactElement } from 'react';
import { Bath, Bed, Home } from 'lucide-react';
import type { ProjectName } from '@/app/projects/types';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import Container from '@/components/ui/layout/container';
import Flex from '@/components/ui/layout/flex';
import Section from '@/components/ui/layout/section';
import {
  TypographyH2,
  TypographyH3,
  TypographySmall,
} from '@/components/ui/typography';
import DETAILS_MAP from './const';

const SECTION_ID = 'project-details';
const IMG_MAP: Record<number, ReactElement> = {
  0: <Home />,
  1: <Bed />,
  2: <Bath />,
};

interface DetailsSectionProperties {
  projectName: ProjectName;
}

function ProjectsDetailsSection({ projectName }: DetailsSectionProperties) {
  const details = DETAILS_MAP[projectName];

  if (!details) {
    return null;
  }

  return (
    <Section id={SECTION_ID}>
      <Container id={SECTION_ID} maxWidth="max-w-5xl">
        <Card variant="secondary">
          <CardHeader className="text-center">
            <TypographyH3>DETAILS</TypographyH3>
            <TypographyH2 className="border-b-0">{projectName}</TypographyH2>
          </CardHeader>

          <CardContent>
            <Flex direction="row" gap="gap-4" className="flex-1">
              {details.map((detail, index) => (
                <TypographySmall key={detail} className="flex flex-row gap-1">
                  {detail && (
                    <>
                      {IMG_MAP[index]}
                      {detail}
                    </>
                  )}
                </TypographySmall>
              ))}
            </Flex>
          </CardContent>
        </Card>
      </Container>
    </Section>
  );
}

export default ProjectsDetailsSection;
